import styled from 'styled-components';

export const FullWidthPaddedColumn = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 20px;
`;
